<template>
  <div></div>
</template>

<script>
export default {
  name: "GamePlayerReal",

  inject: ["onPlayerReady"],

  props: {
    color: {
      type: String,
      default: null,
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    // real player does not need any logic because move was made by the user
    // this function is to keep the interface the same between AiPlayer and RealPlayer
    async nextMove() {},
  },

  mounted() {
    if (this.onPlayerReady) this.onPlayerReady(this.color, this);
  },
};
</script>
